<template>
    <div>
        <nav id="mobile-menu" v-if="menuItems.length">
            <ul>
                <li v-for="menuItem in menuItems"
                    :key="menuItem.id"
                    class="mm-listitem--border"
                    :class="{ 'mm-listitem--header': menuItem.link === 'products' }">
                    <navigation-item-link :menu-item="menuItem"
                                          class="upcase mm-listitem__text"/>

                    <menu-items-tree-mobile :menu-items="menuItem.children">
                        <template #header v-if="menuItem.menu_itemable_type === 'Category'">
                            <li class="mm-listitem--border mm-listitem--header">
                                <nuxt-link :to="{ name: 'categories', params: { name: menuItem.link } }"
                                           class="upcase mm-listitem__text">
                                    SHOP ALL {{ menuItem.name }}
                                </nuxt-link>
                            </li>
                        </template>
                    </menu-items-tree-mobile>
                </li>

                <li v-if="!signedIn">
                    <span @click="logIn">
                        <i class="fas fa-sign-in-alt"></i>
                        Sign in
                    </span>
                </li>

                <li v-if="!signedIn">
                    <span @click="register">
                        <i class="fas fa-user-circle"></i>
                        Create an Account
                    </span>
                </li>

                <li v-if="signedIn">
                    <span @click="logOut">
                        <i class="fas fa-user-circle"></i>
                        Log out
                    </span>
                </li>

                <li v-if="signedIn">
                    <span @click="myAccount">
                        <i class="fas fa-sign-in-alt"></i>
                        My account
                    </span>
                </li>

                <div class="separator"></div>

                <li>
                    <nuxt-link :to="{ name: 'pages-url_handler', params: { url_handler: 'shipping' } }">
                        <i class="fas fa-truck"></i>
                        Shipping Information
                    </nuxt-link>
                </li>
                <li>
                    <nuxt-link :to="{ name: 'pages-url_handler', params: { url_handler: 'return-policy' } }">
                        <img src="@/assets/images/icons/defective-coach.svg" class="mm-listitem__icon" loading="lazy" />
                        Returns, Damages & Exchanges
                    </nuxt-link>
                </li>

                <div class="separator"></div>

                <li>
                    <nuxt-link :to="{ name: 'pages-url_handler', params: { url_handler: 'FAQ' } }">
                        <i class="fas fa-question"></i>
                        FAQ
                    </nuxt-link>
                </li>
                <li>
                    <a href="mailto:support@scoutandnimble.com">
                        <i class="fas fa-envelope"></i>
                        Contact us
                    </a>
                </li>

                <div class="separator"></div>

            </ul>
        </nav>
    </div>
</template>

<script>
    import 'mmenu-js/dist/mmenu.css'
    import 'mmenu-js/dist/mmenu.js'
    import NavigationItemLink from "./navigation/NavigationItemLink"
    import MenuItemsTreeMobile from "./MenuItemsTreeMobile";

    let menu;

    export default {
        name: 'mobile-menu',
        data () {
            return {
                logged: false,
                menuInitialized: false
            }
        },
        components: {
            MenuItemsTreeMobile,
            NavigationItemLink
        },
        methods: {
            register() {
                this.$router.push({name: 'signup'})
                menu.API.close()
            },
            logIn() {
                this.$router.push({name: 'login'})
                menu.API.close()
            },
            logOut() {
                this.$store.dispatch('auth/signOut')
                    .then(() => {
                        console.clear
                        this.$router.push({ name: 'index' })
                    })
                    .catch(error => {
                        console.log(error)
                    })
                menu.API.close()
            },
            myAccount() {
                this.$router.push({name: 'user-dashboard'})
                menu.API.close()
            },
            close () {
                menu.API.close()
            },
            initializeMenu () {
                menu = new Mmenu(document.querySelector('#mobile-menu'),
                    {
                        extensions: [
                            "pagedim-black"
                        ],
                        navbar: {
                            title: null
                        },
                        "navbars": [
                            {
                                "position": "top",
                                "content": [
                                    "<div></div>",
                                    `<a class='sn' href="${window.location}">` +
                                        `<img src="${require('@/../shared/assets/images/main-logo.svg')}" alt="Scout & Nimble" style="width: 235px" loading="lazy" />` +
                                    '</a>',
                                    // "<div class='right'>" +
                                    // "<a href='https://www.scoutandnimble.com/favorites'><i class='fas fa-heart'></i></a>" +
                                    // "</div>"
                                ]
                            }
                        ]
                    }
                )
            }
        },
        computed: {
            signedIn() {
                return this.$store.getters['auth/signedIn']
            },
            menu () {
                return this.$store.getters['menu/getMenu']('main_mobile')
            },
            menuItems () {
                return (this.menu && this.menu.menu_items) || []
            }
        },
        watch: {
            '$route' () {
                menu?.API?.close()
            }
        },
        updated () {
            if (this.menuInitialized) {
                this.menuInitialized = true
                this.initializeMenu()
            }
        },
        mounted () {
            this.initializeMenu()
        },
        beforeDestroy () {
            document.querySelector('#mobile-menu').remove()
        }
    }
</script>

<style lang="scss">

    #mobile-menu {
        font-family: MotivaSans;
    }

    #mobile-menu:not(.mm-menu) {
        display: none;
    }

    .upcase, .mm-navbar__title {
        text-transform: uppercase;
    }

    li, .mm-navbar__title {
        padding-top: 10px;
        padding-left: 20px;
        font-family: MotivaSans;
        font-size: 1.6rem;
        line-height: 1.38;
        letter-spacing: 0.38px;
        color: #000 !important;
    }

    .mm-listitem__text {
        font-family: MotivaSans !important;
        font-size: 1.6rem !important;
        line-height: 1.38 !important;
        letter-spacing: 0.38px !important;
    }

    .mm-navbar {
        color: #000 !important;
        display: grid !important;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 5px;

        &__title {
            line-height: 2.08;
        }

        .sn {
            font-family: Tenez;
            font-size: 3rem;
            line-height: 1.2;
            letter-spacing: 0.9px;
            text-align: center;
            color: #3e3e3e;
        }

        .right {
            justify-self: right;
            align-self: center;
        }

        i {
            font-size: 2rem;
            padding: 5px;
        }
    }

    .mm-panel {
        .mm-navbar {
            grid-template-columns: auto 1fr 0;
        }
    }

    .mm-btn::after, .mm-btn::before {
        border-color: #4e4e4e !important;
        border-width: 4px;
    }

    .mm-btn_next::after, .mm-btn_prev::before {
        width: 13px;
        height: 13px;
    }

    .mm-navbar, .mm-panel, .mm-panels {
        background: #fff !important;
        border-color: #fff !important;
    }

    .mm-listview {
        background: #fff;
        border-color: #fff;
        border-top: 1px solid #ccc;

        .mm-listitem {
            background: #fff;
            border-color: #fff;

            &__icon {
                transform: translateY(6px);
            }

            &__text {
                margin-right: -1px;
                white-space: normal;
                padding-top: 19px;
                padding-bottom: 19px;
            }

            &__btn {
                border-left: 1px solid #ccc;
            }

            &--border {
                border-bottom: 1px solid #ccc;

                &::after {
                    border: none;
                }
            }

            &--header a {
                font-weight: 700 !important;
                color: #653932 !important;
            }
        }
    }

    #mm-1 {
        .mm-listview {
            border-top: none;
        }
    }

    .separator {
        border-bottom: 1px solid #cccccc !important;

        &.mm-listitem::after {
            border: none !important;
        }
    }

</style>
